// extracted by mini-css-extract-plugin
export default {"btn_b":"signup_btn_b__3ypki"};